import { updateFormDescriptionFields, updateFormTitleFields } from './common';
export const generateUpdateRallyPayload = ({ formState, updatedFormFields, }) => ({
    ...(updatedFormFields.has('selectedThemes') ? { themes: formState.selectedThemes } : {}),
    ...(updatedFormFields.has('internalTitle') ? { internalTitle: formState.internalTitle } : {}),
    ...updateFormTitleFields({ formState, updatedFormFields }),
    ...updateFormDescriptionFields({ formState, updatedFormFields }),
    ...(updatedFormFields.has('selectedTargetGroups')
        ? { targetGroups: formState.selectedTargetGroups }
        : {}),
    ...(updatedFormFields.has('isTeamRally') ? { isTeamRally: formState.isTeamRally } : {}),
    ...(updatedFormFields.has('isLinearRally') ? { isLinear: formState.isLinearRally } : {}),
    ...(updatedFormFields.has('isPublicRally')
        ? { visibility: formState.isPublicRally ? 'public' : 'private' }
        : {}),
    ...(updatedFormFields.has('badge') ? { badge: formState.badge ? formState.badge : '' } : {}),
    ...(updatedFormFields.has('image') ? { image: formState.image ? formState.image : '' } : {}),
    ...(updatedFormFields.has('isRallyTimeLimit') ? { isTimeLimit: formState.isRallyTimeLimit } : {}),
    ...(updatedFormFields.has('minutes') ? { maxDuration: Number(formState.minutes) } : {}),
    ...(updatedFormFields.has('latitude') ? { latitude: formState.latitude } : {}),
    ...(updatedFormFields.has('longitude') ? { longitude: formState.longitude } : {}),
});
